if ( window.location.pathname !== "/" ) {
  document.addEventListener('DOMContentLoaded', () => {
    loadCorrectImage();
  })
}


function loadCorrectImage() {
  var cookie = Cookies.get('PJS-Gender');
  var maleImages = document.querySelectorAll('img[data-male]');
  var femaleImages = document.querySelectorAll('img[data-female]');
  var flatlayImages = document.querySelectorAll('img[data-flatlay]');
  var defaultImages = document.querySelectorAll('img[data-default]');
  var genderSelectorsMale = document.querySelectorAll('.gender-selector-male')
  var genderSelectorsFemale = document.querySelectorAll('.gender-selector-female')
  var genderSelectorsFlatlay = document.querySelectorAll('.gender-selector-flatlay')

  if (cookie == 'Female') {
    for (let i = 0; i < femaleImages.length; i++) {
      const element = femaleImages[i];
      element.classList.remove('hide')
    }
    for (let i = 0; i < maleImages.length; i++) {
      const element = maleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < flatlayImages.length; i++) {
      const element = flatlayImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < defaultImages.length; i++) {
      const element = defaultImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < genderSelectorsFemale.length; i++) {
      const element = genderSelectorsFemale[i];
      element.classList.add('active')
    }
    for (let i = 0; i < genderSelectorsMale.length; i++) {
      const element = genderSelectorsMale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsFlatlay.length; i++) {
      const element = genderSelectorsFlatlay[i];
      element.classList.remove('active')
    }
  } else if (cookie == 'Male') {
    for (let i = 0; i < femaleImages.length; i++) {
      const element = femaleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < maleImages.length; i++) {
      const element = maleImages[i];
      element.classList.remove('hide')
    }
    for (let i = 0; i < flatlayImages.length; i++) {
      const element = flatlayImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < defaultImages.length; i++) {
      const element = defaultImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < genderSelectorsFemale.length; i++) {
      const element = genderSelectorsFemale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsMale.length; i++) {
      const element = genderSelectorsMale[i];
      element.classList.add('active')
    }
    for (let i = 0; i < genderSelectorsFlatlay.length; i++) {
      const element = genderSelectorsFlatlay[i];
      element.classList.remove('active')
    }
  } else if (cookie == 'Flatlay') {
    for (let i = 0; i < femaleImages.length; i++) {
      const element = femaleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < maleImages.length; i++) {
      const element = maleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < flatlayImages.length; i++) {
      const element = flatlayImages[i];
      element.classList.remove('hide')
    }
    for (let i = 0; i < defaultImages.length; i++) {
      const element = defaultImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < genderSelectorsFemale.length; i++) {
      const element = genderSelectorsFemale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsMale.length; i++) {
      const element = genderSelectorsMale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsFlatlay.length; i++) {
      const element = genderSelectorsFlatlay[i];
      element.classList.add('active')
    }
  }
}

function pdpSelect(display) {
  var flatLay = document.querySelector('.product--images.flatlay');
  var model = document.querySelector('.product--images.model');
  var genderSelectorsFlatlay = document.querySelector('.pdp-flatlay');
  var genderSelectorsMale = document.querySelector('.pdp-model');
  
  // console.log(genderSelectorsFlatlay);
  // console.log(genderSelectorsMale);

  if (display == "flatlay") {
    genderSelectorsFlatlay.classList.add('active');
    genderSelectorsMale.classList.remove('active');
    flatLay.style.display = "block";
    model.style.display = "none";
  } else {
    genderSelectorsFlatlay.classList.remove('active');
    genderSelectorsMale.classList.add('active');
    flatLay.style.display = "none";
    model.style.display = "block";
  }
}

function genderSelect(gender) {
  var maleImages = document.querySelectorAll('img[data-male]');
  var femaleImages = document.querySelectorAll('img[data-female]');
  var flatlayImages = document.querySelectorAll('img[data-flatlay]');
  var defaultImages = document.querySelectorAll('img[data-default]');
  var genderSelectorsMale = document.querySelectorAll('.gender-selector-male')
  var genderSelectorsFemale = document.querySelectorAll('.gender-selector-female')
  var genderSelectorsFlatlay = document.querySelectorAll('.gender-selector-flaylay')

  if (gender == 'male') {
    Cookies.set('PJS-Gender', 'Male', { expires: 1 });
    for (let i = 0; i < maleImages.length; i++) {
      const element = maleImages[i];
      element.classList.remove('hide')
    }
    for (let i = 0; i < femaleImages.length; i++) {
      const element = femaleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < flatlayImages.length; i++) {
      const element = flatlayImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < defaultImages.length; i++) {
      const element = defaultImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < genderSelectorsMale.length; i++) {
      const element = genderSelectorsMale[i];
      element.classList.add('active')
    }
    for (let i = 0; i < genderSelectorsFemale.length; i++) {
      const element = genderSelectorsFemale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsFlatlay.length; i++) {
      const element = genderSelectorsFlatlay[i];
      element.classList.remove('active')
    }
  } else if (gender=='female') {
    Cookies.set('PJS-Gender', 'Female', { expires: 1 });
    for (let i = 0; i < maleImages.length; i++) {
      const element = maleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < femaleImages.length; i++) {
      const element = femaleImages[i];
      element.classList.remove('hide')
    }
    for (let i = 0; i < flatlayImages.length; i++) {
      const element = flatlayImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < defaultImages.length; i++) {
      const element = defaultImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < genderSelectorsFemale.length; i++) {
      const element = genderSelectorsFemale[i];
      element.classList.add('active')
    }
    for (let i = 0; i < genderSelectorsMale.length; i++) {
      const element = genderSelectorsMale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsFlatlay.length; i++) {
      const element = genderSelectorsFlatlay[i];
      element.classList.remove('active')
    }
  } else if (gender == 'flatlay'){
    Cookies.set('PJS-Gender', 'Flatlay', { expires: 1 });
    for (let i = 0; i < maleImages.length; i++) {
      const element = maleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < femaleImages.length; i++) {
      const element = femaleImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < flatlayImages.length; i++) {
      const element = flatlayImages[i];
      element.classList.remove('hide')
    }
    for (let i = 0; i < defaultImages.length; i++) {
      const element = defaultImages[i];
      element.classList.add('hide')
    }
    for (let i = 0; i < genderSelectorsFemale.length; i++) {
      const element = genderSelectorsFemale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsMale.length; i++) {
      const element = genderSelectorsMale[i];
      element.classList.remove('active')
    }
    for (let i = 0; i < genderSelectorsFlatlay.length; i++) {
      const element = genderSelectorsFlatlay[i];
      element.classList.add('active')
    }
  }
}